import React from "react";
import PropTypes from "prop-types";

import { Option } from "./Option";
import { GroupHeading } from "./GroupHeading";

export const Group = ({ children, isKeyUsed, selectProps, label, onSelectAll, onUnselectAll, options }) => {
  const isAllOptionsSelected = options.every(option => option.isSelected);

  return (
    <div className="checkbox__group">
      <GroupHeading
        inputValue={selectProps.inputValue}
        onSelectAll={onSelectAll}
        onUnselectAll={onUnselectAll}
        isAllOptionsSelected={isAllOptionsSelected}>
        {label}
      </GroupHeading>
      {options.map(option => {
        const sameLabelOptions = children.filter(child => child.props.label === option.label) || [];
        const optionProps = children.find(child => child.props.value === option.value) || {};
        return <Option isKeyUsed={isKeyUsed} key={option.value} showValueInLabel={sameLabelOptions.length > 1} {...optionProps.props} />;
      })}
    </div>
  );
};

Group.propTypes = {
  children: PropTypes.array,
  isKeyUsed: PropTypes.bool,
  label: PropTypes.string,
  onSelectAll: PropTypes.func,
  onUnselectAll: PropTypes.func,
  options: PropTypes.array,
  selectProps: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/MultiSelect/Group.js